import { setPageName } from "../redux/actions";
import { useDispatch } from "react-redux";
import { goPage } from "../system/coords";

// Images - logos
// import {configureStore} from "@reduxjs/toolkit";

const ArrowIcon = "/assets/images/arrow.svg";

const techAWS = "/assets/images/tech/aws.png";
const techBash = "/assets/images/tech/bash.png";
const techC = "/assets/images/tech/c.png";
const techCSS = "/assets/images/tech/css.png";
const techDocker = "/assets/images/tech/docker.png";
const techGit = "/assets/images/tech/git.png";
const techGitHub = "/assets/images/tech/github.png";
const techHTML = "/assets/images/tech/html.png";
const techJavaScript = "/assets/images/tech/javascript.png";
const techJest = "/assets/images/tech/jest.png";
const techLinux = "/assets/images/tech/linux.png";
const techMySQL = "/assets/images/tech/mysql.png";
const techNASM = "/assets/images/tech/nasm.png";
const techNginx = "/assets/images/tech/nginx.png";
const techNode = "/assets/images/tech/node.png";
const techPhotoshop = "/assets/images/tech/photoshop.png";
const techPHP = "/assets/images/tech/php.png";
const techPython = "/assets/images/tech/python.png";
const techReact = "/assets/images/tech/react.png";
const techRedux = "/assets/images/tech/redux.png";
const techSass = "/assets/images/tech/sass.png";
const techTypeScript = "/assets/images/tech/typescript.png";
const techWebpack = "/assets/images/tech/webpack.png";

const TT = (elem, tgt, vis) => {
  let left = 0;
  let leftShift = 0;
  if (elem) {
    setTimeout(() => {
      left = elem.getBoundingClientRect().left;
      leftShift = Math.round(
        (elem.getBoundingClientRect().width - document.querySelector("#" + tgt).getBoundingClientRect().width) / 2,
      );
      document.querySelector("#" + tgt).style.left = Math.round(left - 10 + leftShift) + "px";
    }, 0);
    const alt = elem.alt;
    document.querySelector("#" + tgt).innerHTML = alt;
  }
  document.querySelector("#" + tgt).style.opacity = "show" === vis ? "1" : "0";
};

const TechContent = () => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="Tech center full-height">
        <p className="Tech-intro">
          Capabilities across languages and tech are below, <span className="Tech-intro-mobile-break"></span>roughly
          grouped into 3 sets:
        </p>
        <p className="Tech-headings orange">Expert</p>
        <p className="Tech-headings-note">(20+ years, superb usage)</p>
        <div>
          <div id="TT1" className="tooltip"></div>
          <img
            src={techHTML}
            alt="HTML"
            onMouseOver={evt => {
              TT(evt.target, "TT1", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT1", "hide");
            }}
          />
          <img
            src={techCSS}
            alt="CSS"
            onMouseOver={evt => {
              TT(evt.target, "TT1", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT1", "hide");
            }}
          />
          <img
            src={techJavaScript}
            alt="JavaScript"
            onMouseOver={evt => {
              TT(evt.target, "TT1", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT1", "hide");
            }}
          />
          <img
            src={techLinux}
            alt="Linux"
            onMouseOver={evt => {
              TT(evt.target, "TT1", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT1", "hide");
            }}
          />
          <img
            src={techBash}
            alt="Bash (& Shell)"
            onMouseOver={evt => {
              TT(evt.target, "TT1", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT1", "hide");
            }}
          />
          <img
            src={techPHP}
            alt="PHP"
            className="Tech-php"
            onMouseOver={evt => {
              TT(evt.target, "TT1", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT1", "hide");
            }}
          />
          <img
            src={techPhotoshop}
            alt="Photoshop"
            onMouseOver={evt => {
              TT(evt.target, "TT1", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT1", "hide");
            }}
          />
        </div>
        <p className="Tech-headings blue">Proficient</p>
        <p className="Tech-headings-note">(10+ years, advanced usage)</p>
        <div>
          <div id="TT2" className="tooltip"></div>
          <img
            src={techSass}
            alt="Sass"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techPython}
            alt="Python"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techNode}
            alt="Node"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techMySQL}
            alt="MySQL"
            className="Tech-mysql"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techGit}
            alt="Git"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techGitHub}
            alt="GitHub"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techDocker}
            alt="Docker"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techAWS}
            alt="AWS"
            className="Tech-aws"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
          <img
            src={techNginx}
            alt="Nginx"
            onMouseOver={evt => {
              TT(evt.target, "TT2", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT2", "hide");
            }}
          />
        </div>
        <p className="Tech-headings purple">Sufficient</p>
        <p className="Tech-headings-note">(3+ years, great usage)</p>
        <div>
          <div id="TT3" className="tooltip"></div>
          <img
            src={techReact}
            alt="React"
            onMouseOver={evt => {
              TT(evt.target, "TT3", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT3", "hide");
            }}
          />
          <img
            src={techRedux}
            alt="Redux"
            onMouseOver={evt => {
              TT(evt.target, "TT3", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT3", "hide");
            }}
          />
          <img
            src={techTypeScript}
            alt="TypeScript"
            onMouseOver={evt => {
              TT(evt.target, "TT3", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT3", "hide");
            }}
          />
          <img
            src={techJest}
            alt="Jest"
            onMouseOver={evt => {
              TT(evt.target, "TT3", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT3", "hide");
            }}
          />
          <img
            src={techWebpack}
            alt="Webpack"
            onMouseOver={evt => {
              TT(evt.target, "TT3", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT3", "hide");
            }}
          />
          <img
            src={techC}
            alt="C"
            onMouseOver={evt => {
              TT(evt.target, "TT3", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT3", "hide");
            }}
          />
          <img
            src={techNASM}
            alt="NASM"
            onMouseOver={evt => {
              TT(evt.target, "TT3", "show");
            }}
            onMouseOut={() => {
              TT(this, "TT3", "hide");
            }}
          />
        </div>
        <p>Currently learning: Go and Java</p>
      </div>
      <img
        src={ArrowIcon}
        className="Arrow-icon Arrow-Tech"
        alt="Go to next page"
        onClick={() => {
          goPage("Showcase");
          dispatch(setPageName("Showcase"));
        }}
      />
    </>
  );
};

export default TechContent;
